export default "__VITE_PUBLIC_ASSET__4fcc7817__"